import { getProductBySlug, getProductsByCategory, getAllProducts, getCategories } from '../data/products.js'

// Product service for centralized data access
// This makes it easy to switch to JSON/API later

export const productService = {
  // Get a specific product by category and slug
  getProduct: (category, slug) => {
    return getProductBySlug(category, slug)
  },

  // Get all products in a category
  getProductsByCategory: (category) => {
    return getProductsByCategory(category)
  },

  // Get all products across all categories
  getAllProducts: () => {
    return getAllProducts()
  },

  // Get all available categories
  getCategories: () => {
    return getCategories()
  },

  // Check if a product exists
  productExists: (category, slug) => {
    return !!getProductBySlug(category, slug)
  },

  // Get related products (same category, excluding current product)
  getRelatedProducts: (category, currentSlug, limit = 3) => {
    const categoryProducts = getProductsByCategory(category)
    return categoryProducts
      .filter(product => product.slug !== currentSlug)
      .slice(0, limit)
  }
}

// Future: Easy migration to JSON/API
// Just replace the imports and add async/await where needed
// export const productService = {
//   getProduct: async (category, slug) => {
//     const response = await fetch(`/api/products/${category}/${slug}`)
//     return response.json()
//   },
//   // ... other methods
// }

